import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/auth';

const STATS = [
  {
    label: 'Vendors',
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
    shadow: 'rgba(59,130,246,0.25)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    path: '/on/vendors',
  },
  {
    label: 'Employees',
    gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    shadow: 'rgba(16,185,129,0.25)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    path: '/on/employees',
  },
  {
    label: 'Invoices',
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    shadow: 'rgba(245,158,11,0.25)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    ),
    path: '/on/invoices',
  },
  {
    label: 'Timesheets',
    gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
    shadow: 'rgba(236,72,153,0.25)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    path: '/on/timesheets',
  },
];

const QUICK_ACTIONS = [
  { label: 'New Vendor', path: '/on/vendors/new', color: '#3b82f6' },
  { label: 'New Employee', path: '/on/employees/new', color: '#10b981' },
  { label: 'New Timesheet', path: '/on/timesheets/new', color: '#f59e0b' },
  { label: 'New Invoice', path: '/on/invoices/new', color: '#ec4899' },
  { label: 'New Billing', path: '/on/billings/new', color: '#8b5cf6' },
];

const StatCard = ({ label, gradient, shadow, icon, path }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate(path)}
      style={{
        background: '#ffffff',
        borderRadius: '14px',
        padding: '22px 20px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04), 0 6px 16px rgba(0,0,0,0.06)',
        border: '1px solid #f1f5f9',
        flex: '1 1 180px',
        display: 'flex', alignItems: 'center', gap: '16px',
        cursor: 'pointer', transition: 'transform 0.18s ease, box-shadow 0.18s ease',
      }}
      onMouseOver={e => {
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = `0 8px 24px ${shadow}, 0 2px 8px rgba(0,0,0,0.06)`;
      }}
      onMouseOut={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.04), 0 6px 16px rgba(0,0,0,0.06)';
      }}
    >
      <div style={{
        width: '50px', height: '50px', borderRadius: '13px',
        background: gradient, flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: `0 4px 12px ${shadow}`,
      }}>
        {icon}
      </div>
      <div>
        <div style={{ fontSize: '12px', color: '#94a3b8', fontWeight: '600', letterSpacing: '0.3px', marginBottom: '4px' }}>
          {label}
        </div>
        <div style={{ fontSize: '22px', fontWeight: '800', color: '#1e293b', lineHeight: 1 }}>—</div>
      </div>
    </div>
  );
};

const QuickAction = ({ label, path, color }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(path)}
      style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        padding: '10px 18px', borderRadius: '9px',
        border: `1px solid ${color}30`,
        background: `${color}0d`,
        color: color, cursor: 'pointer',
        fontSize: '13px', fontWeight: '600',
        transition: 'all 0.15s ease',
      }}
      onMouseOver={e => {
        e.currentTarget.style.background = `${color}22`;
        e.currentTarget.style.transform = 'translateY(-1px)';
        e.currentTarget.style.boxShadow = `0 4px 12px ${color}30`;
      }}
      onMouseOut={e => {
        e.currentTarget.style.background = `${color}0d`;
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      {label}
    </button>
  );
};

const LandingScreen = () => {
  const { token } = useAuth();

  const parseJwt = (t) => {
    try { return JSON.parse(atob(t.split('.')[1])); } catch { return null; }
  };

  const tokenData = token ? parseJwt(token) : null;
  const givenName = tokenData?.given_name || 'User';
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });

  return (
    <div style={{ padding: '32px', maxWidth: '1100px', margin: '0 auto' }}>

      {/* Welcome banner */}
      <div style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #1a2744 100%)',
        borderRadius: '18px',
        padding: '36px 40px',
        marginBottom: '32px',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(15,23,42,0.18)',
      }}>
        {/* Decorative blobs */}
        <div style={{
          position: 'absolute', top: '-50px', right: '-50px',
          width: '220px', height: '220px', borderRadius: '50%',
          background: 'rgba(59,130,246,0.08)',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', bottom: '-70px', right: '120px',
          width: '180px', height: '180px', borderRadius: '50%',
          background: 'rgba(99,102,241,0.07)',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', top: '20px', right: '200px',
          width: '80px', height: '80px', borderRadius: '50%',
          background: 'rgba(139,92,246,0.06)',
          pointerEvents: 'none',
        }} />

        <div style={{ position: 'relative' }}>
          <div style={{ fontSize: '12px', color: '#475569', fontWeight: '600', letterSpacing: '0.5px', marginBottom: '10px' }}>
            {today}
          </div>
          <h1 style={{
            margin: '0 0 10px', fontSize: '30px', fontWeight: '800',
            color: '#f8fafc', letterSpacing: '-0.3px',
          }}>
            Welcome back, {givenName} 👋
          </h1>
          <p style={{ margin: 0, fontSize: '14px', color: '#64748b', maxWidth: '480px' }}>
            Manage your vendors, employees, invoices, and timesheets all in one place.
          </p>
        </div>
      </div>

      {/* Section: Overview */}
      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '11px', fontWeight: '700', color: '#94a3b8', letterSpacing: '1.2px', textTransform: 'uppercase' }}>Overview</span>
        <div style={{ flex: 1, height: '1px', background: '#f1f5f9' }} />
      </div>
      <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '32px' }}>
        {STATS.map(s => <StatCard key={s.label} {...s} />)}
      </div>

      {/* Section: Quick Actions */}
      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '11px', fontWeight: '700', color: '#94a3b8', letterSpacing: '1.2px', textTransform: 'uppercase' }}>Quick Actions</span>
        <div style={{ flex: 1, height: '1px', background: '#f1f5f9' }} />
      </div>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        {QUICK_ACTIONS.map(a => <QuickAction key={a.label} {...a} />)}
      </div>
    </div>
  );
};

export default LandingScreen;
